import React from "react";
import { Flex, Text, Grid, GridItem, Box, Button } from "@chakra-ui/react";
import styles from "./ProductPage.module.css";
import Footer from "../components/Footer";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Slider from "react-slick";
import Comparison from "../components/Comparison";
import { color } from "framer-motion";

const ProductPage = () => {
  return (
    <Flex className={styles.container}>
      <Flex className={styles.headerContainer}>
        <img
          src="/assets/kuriabar/banner.png"
          alt="Kuriabar banner"
          className={styles.headerBg}
        />
        <Flex className={styles.headerTextContainer}>
          <Text className={styles.headerTitleText}>KURIA </Text>
          <Text className={styles.headerTitleText}>BAR</Text>
        </Flex>
      </Flex>

      <Flex className={styles.infoSection}>
        <Text className={styles.infoText}>
          KURIA BAR adalah{" "}
          <a className={styles.infoText2}>tulangan beton alternatif</a> berbahan{" "}
          <a className={styles.infoText2}>Fiber Glass</a> (Glassfiber
          Reinforcement Polymer) yang dirancang untuk aplikasi beban berat.
          Hadir sebagai solusi alternatif tulangan beton yang{" "}
          <a className={styles.infoText2}>
            tahan korosi, berkekuatan tinggi, dan ramah lingkungan.
          </a>
        </Text>
      </Flex>

      <Flex className={styles.sizesSection}>
        <Flex className={styles.sizesTextContainer}>
          <Text className={styles.sizesTitle}>
            Tersedia
            <br /> dalam <br />
            Berbagai <br />
            Ukuran
          </Text>
          <Text className={styles.sizesSubTitle}>
            Diameter Kuria Bar bervariasi dari 5 mm hingga 22 mm, dapat
            didiskusikan dengan minimum pembelian.
          </Text>
        </Flex>
        <img
          className={styles.sizesImg}
          src="/assets/kuriabar/measurements.png"
        />
      </Flex>

      <Flex className={styles.promptSection}>
        <img
          src="/assets/kuriabar/prompt-banner.png"
          alt="Prompt Banner"
          className={styles.promptBg}
        />
        <Flex className={styles.promptTextContainer}>
          <Text className={styles.promptText}>Pesan hingga</Text>
          <Text className={styles.promptText2}>100m</Text>
          <a
            href="https://wa.me/6285117255773"
            target="_blank"
            rel="noreferrer"
          >
            <Button
              className={styles.promptButton}
              bg="#ea2e01"
              color="white"
              _hover={{ bg: "#d42a00" }}
              fontSize={{
                base: "14px",
                md: "16px",
                "2xl": "24px",
              }}
            >
              CEK HARGA
            </Button>
          </a>
        </Flex>
      </Flex>

      {/* Comparison Section  */}
      <Comparison />

      {/* Lab Test Results Section  */}
      <Flex className={styles.scientificSection}>
        <Text className={styles.scientificTitle}>Hasil Uji Lab Terbukti</Text>

        {/* Hero Section */}
        <Flex className={styles.scientificHero}>
          <Flex className={styles.scientificStats}>
            <Flex className={styles.scientificStatBlock}>
              <Text className={styles.scientificStatNumber}>3x</Text>
              <Text className={styles.scientificStatLabel}>LEBIH KUAT</Text>
              <Text className={styles.scientificStatDesc}>
                Teruji dengan kuat tarik 1000 N/mm² dibandingkan dengan besi
                beton yang hanya 280-420 N/mm².
              </Text>
            </Flex>
            <Flex className={styles.scientificStatBlock}>
              <Text className={styles.scientificStatNumber}>1/4x</Text>
              <Text className={styles.scientificStatLabel}>LEBIH RINGAN</Text>
              <Text className={styles.scientificStatDesc}>
                Dengan diameter yang sama dengan besi beton, KURIA bar lebih
                ringan hingga 1/4x nya.
              </Text>
            </Flex>
          </Flex>
          <img
            className={styles.scientificHeroImg}
            src="/assets/kuriabar/lab-hero.png"
            alt="Hasil Uji Lab"
          />
        </Flex>

        {/* Uji Lekat Section */}
        <Text className={styles.scientificSubtitle}>Uji Lekat</Text>
        <Flex className={styles.scientificGrid}>
          <img
            className={styles.scientificGridImg}
            src="/assets/kuriabar/uji-lekat-1.png"
            alt="Uji Lekat 1"
          />
          <img
            className={styles.scientificGridImg}
            src="/assets/kuriabar/uji-lekat-2.png"
            alt="Uji Lekat 2"
          />
          <img
            className={styles.scientificGridImg}
            src="/assets/kuriabar/uji-lekat-3.png"
            alt="Uji Lekat 3"
          />
          <img
            className={styles.scientificGridImg}
            src="/assets/kuriabar/uji-lekat-4.png"
            alt="Uji Lekat 4"
          />
        </Flex>

        {/* Uji Lentur Section */}
        <Text className={styles.scientificSubtitle}>Uji Lentur</Text>
        <img
          className={styles.scientificCenterImg}
          src="/assets/kuriabar/uji-lentur.png"
          alt="Uji Lentur"
        />
      </Flex>

      {/* Application Section  */}
      <Flex className={styles.applicationSection}>
        <Text className={styles.applicationHeader}>Application</Text>
        <ApplicationsCarouselMobile />
        <ApplicationsDesktop />
      </Flex>

      {/* Our Projects Section  */}
      <Flex className={styles.projectsSection}>
        <Text className={styles.projectsTitle}>
          Membangun Konstruksi <br /> Membentuk Industri
        </Text>
        <ProjectsCarousel />
      </Flex>

      {/* Callout Section  */}
      <Flex className={styles.callOutBanner}>
        <Flex className={styles.callOutContent}>
          <Text className={styles.callOutText}>Tertarik Pakai Kuria?</Text>
          <a
            href="https://wa.me/6285117255773"
            target="_blank"
            rel="noreferrer"
          >
            <Box as="button" className={styles.callOutButton}>
              COBA KURIA SEKARANG
            </Box>
          </a>
        </Flex>
      </Flex>

      <Footer />
    </Flex>
  );
};

export default ProductPage;

function ProjectsCarousel() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    // appendDots: (dots) => (
    //   <ul style={{ margin: "0px", marginBottom: "72px" }}> {dots} </ul>
    // ),
  };

  return (
    <div className={`${styles.carouselContainer} customDotsCarousel`}>
      <Slider {...settings}>
        <div className={styles.slide}>
          <iframe
            id="ytplayer"
            type="text/html"
            width="100%"
            height="100%"
            src="https://www.youtube.com/embed/-SnAxVNiwM8"
            frameborder="0"
          ></iframe>
        </div>
        <div className={styles.slide}>
          <iframe
            id="ytplayer"
            type="text/html"
            width="100%"
            height="100%"
            src="https://www.youtube.com/embed/011UBHlV8mc"
            frameborder="0"
          ></iframe>
        </div>

        <div className={styles.slide}>
          <iframe
            id="ytplayer"
            type="text/html"
            width="100%"
            height="100%"
            src="https://www.youtube.com/embed/xIImhqOh5Js"
            frameborder="0"
          ></iframe>
        </div>
      </Slider>
    </div>
  );
}

function NextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <img
      src="rightArrow.png"
      alt="Next"
      className={`${className} ${styles.arrow}`}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    />
  );
}

function PrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <img
      src="leftArrow.png"
      alt="Prev"
      className={`${className} ${styles.arrow}`}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    />
  );
}

function ApplicationsDesktop() {
  return (
    <Grid className={styles.applicationImgContainer}>
      <GridItem rowSpan={2} colSpan={1}>
        <Flex
          className={styles.applicationTextContainer}
          backgroundColor="#EA2E01"
        >
          <Text className={styles.applicationText} color="white">
            INDUSTRIAL
          </Text>
          <Text className={styles.applicationSubText} color="white">
            Pabrik kimia | Pembangkit listrik | Anjungan minyak dan gas
          </Text>
        </Flex>

        <img
          className={styles.applicationImg}
          src="6_Application 1.png"
          alt="Application"
        />
      </GridItem>

      <GridItem rowSpan={2} colSpan={1}>
        <img className={styles.applicationImg} src="6_Application 2.png" />
        <Flex className={styles.applicationTextContainer}>
          <Text className={styles.applicationText}>BANGUNAN</Text>
          <Text className={styles.applicationSubText}>
            Fondasi | Kolom dan Balok | Pelat | Dinding
          </Text>
        </Flex>
      </GridItem>
      <GridItem rowSpan={2} colSpan={1}>
        <Flex className={styles.applicationTextContainer}>
          <Text className={styles.applicationText} width="80%">
            KONSTRUKSI
          </Text>
          <Text className={styles.applicationSubText}>
            Jembatan | Bangunan | Garasi parkir | Struktur Kelautan | Struktur
            Pesisir
          </Text>
        </Flex>
        <img className={styles.applicationImg} src="6_Application 3.png" />
      </GridItem>
      <GridItem rowSpan={2} colSpan={1}>
        <img className={styles.applicationImg} src="6_Application 4.png" />
        <Flex
          className={styles.applicationTextContainer}
          backgroundColor="#EA2E01"
        >
          <Text className={styles.applicationText} color="white">
            INFRASTRUKTUR
          </Text>
          <Text className={styles.applicationSubText} color="white">
            Instalasi pengolahan air | Instalasi pengolahan air limbah |
            Terowongan | Pipa
          </Text>
        </Flex>
      </GridItem>
    </Grid>
  );
}

function ApplicationsCarouselMobile() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    appendDots: (dots) => (
      <ul style={{ margin: "0px", marginBottom: "48px" }}> {dots} </ul>
    ),
  };

  return (
    <div className={styles.sliderContainer}>
      <Slider {...settings}>
        {/* TODO: each item here is copy pasted from ProjectsDesktop for now, but we should be able to share the code between the two */}
        <div>
          <Flex className={styles.applicationTextContainer}>
            <Text className={styles.applicationText}>INDUSTRIAL</Text>
            <Text className={styles.applicationSubText}>
              Pabrik kimia | Pembangkit listrik | Anjungan minyak dan gas
            </Text>
          </Flex>

          <img
            className={styles.applicationImg}
            src="6_Application 1.png"
            alt="Application"
          />
        </div>
        <div>
          <Flex className={styles.applicationTextContainer}>
            <Text className={styles.applicationText}>BANGUNAN</Text>
            <Text className={styles.applicationSubText}>
              Fondasi | Kolom dan Balok | Pelat | Dinding
            </Text>
          </Flex>
          <img className={styles.applicationImg} src="6_Application 2.png" />
        </div>
        <div>
          <Flex className={styles.applicationTextContainer}>
            <Text className={styles.applicationText} width="80%">
              KONSTRUKSI
            </Text>
            <Text className={styles.applicationSubText}>
              Jembatan | Bangunan | Garasi parkir | Struktur Kelautan | Struktur
              Pesisir
            </Text>
          </Flex>
          <img className={styles.applicationImg} src="6_Application 3.png" />
        </div>
        <div>
          <Flex className={styles.applicationTextContainer}>
            <Text className={styles.applicationText}>INFRASTRUKTUR</Text>
            <Text className={styles.applicationSubText}>
              Instalasi pengolahan air | Instalasi pengolahan air limbah |
              Terowongan | Pipa
            </Text>
          </Flex>
          <img className={styles.applicationImg} src="6_Application 4.png" />
        </div>
      </Slider>
    </div>
  );
}
